import { downloadTextFile, rowsToCsv } from '@/api/csvExport';

export const SCHEDULED_RUN_HISTORY_TABLE_COLUMNS = [
  'run_time',
  'evaluated_ist_hour',
  'status',
  'multiplier_applied',
  'effective_increment',
  'message',
  'old_budget',
  'new_budget',
] as const;

export const SCHEDULED_RUN_HISTORY_CSV_FILENAME = 'scheduled-run-history.csv';

function csvCellValue(value: unknown): string | number | null | undefined {
  if (value === null || value === undefined) return '';
  if (typeof value === 'object') return JSON.stringify(value);
  if (typeof value === 'boolean') return value ? 'true' : 'false';
  return value as string | number;
}

export function collectScheduledRunHistoryHeaders(
  logs: Record<string, unknown>[]
): string[] {
  const keySet = new Set<string>();
  for (const row of logs) {
    for (const key of Object.keys(row)) {
      keySet.add(key);
    }
  }

  const preferred = [
    ...(keySet.has('id') ? ['id'] : []),
    ...SCHEDULED_RUN_HISTORY_TABLE_COLUMNS.filter((key) => keySet.has(key)),
  ];
  const preferredSet = new Set(preferred);
  const extras = [...keySet].filter((key) => !preferredSet.has(key)).sort();
  return [...preferred, ...extras];
}

export function scheduledRunLogToCsvRow(
  row: Record<string, unknown>,
  headers: string[]
): (string | number | null | undefined)[] {
  return headers.map((header) => csvCellValue(row[header]));
}

export function downloadScheduledRunHistoryCsv(logs: Record<string, unknown>[]): void {
  if (logs.length === 0) return;
  const headers = collectScheduledRunHistoryHeaders(logs);
  const csv = rowsToCsv(headers, logs.map((row) => scheduledRunLogToCsvRow(row, headers)));
  downloadTextFile(SCHEDULED_RUN_HISTORY_CSV_FILENAME, csv);
}
